module.exports = __webpack_public_path__ + "img/healthcare-splash.30da0f52.svg";